// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3HJa7","footer":"styles_footer__2wG_W","passCodeTooltip":"styles_passCodeTooltip__2SJRh"};